import { render, staticRenderFns } from "./MemberPhoto.vue?vue&type=template&id=3ab36216&scoped=true&"
import script from "./MemberPhoto.vue?vue&type=script&lang=js&"
export * from "./MemberPhoto.vue?vue&type=script&lang=js&"
import style0 from "./MemberPhoto.vue?vue&type=style&index=0&id=3ab36216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab36216",
  null
  
)

export default component.exports